import thunkMiddleware from 'redux-thunk';
import { combineReducers, configureStore, } from '@reduxjs/toolkit';
import rootReducer from './reducer';
var store = configureStore({
    reducer: combineReducers(rootReducer),
    middleware: [thunkMiddleware],
});
export default store;
